import { getDatasWithOption, handleApiError } from '../../utils/service';
import { truthy, falsy, parseInt10, numberWithCommas } from '../../utils/util';
import { getLoadingBarTpl } from '../../model/tpl/loadingbar';
import { BOARD } from '../../model/msg/board';
import Navi from '../../component/navi/Navi';

class Connect {
  constructor(options) {
    const _ = this;

    if (!options) return;

    _.option = $.extend({
      wrap: null,
      apiDomain: '',
      global: window
    }, options);

    _.wrap = _.option.wrap;

    _.pledgeWrap = $('#chracteron__pledge', _.wrap);

    _.friendWrap = $('#chracteron__friend', _.wrap);

    _.navi = null;

    _.currentNaviIndex = 1;

    _.isPledgeNoData = false;
    _.isFriendNoData = false;

    _.tpl = {
      JOIN_PLEDGE: `<div class="nodata">
                     <p>게임 내 채팅창에서 <strong>'/혈맹'</strong> 입력 후<br /> 원하는 혈맹을 찾아 가입해 보세요.</p>
                     <a href="/powerbook/wiki/%ED%98%88%EB%A7%B9">혈맹 알아보기</a>
                   </div>`
    };
  }

  init() {
    const _ = this;

    _.pledgeWrap.empty();
    _.friendWrap.empty();

    _.setInstance();

    return _;
  }

  setInstance() {
    const _ = this;

    _.setNaviOnlineCountData();
    _.setNavi();
    _.navi.activate(_.currentNaviIndex);

    _.setConnectData('pledge');
    _.setConnectData('friend');
  }

  setConnectData(serviceName) {
    const _ = this,
      wrap = _[`${serviceName}Wrap`];

    _.setLoadingBar(wrap, true);

    getDatasWithOption([{
      type: 'GET',
      url: `${_.option.apiDomain}/api/main/connection/${serviceName}`,
      dataType: 'json',
      xhrFields: {withCredentials: true}

    }], (data) => {
      _.setLoadingBar(wrap, false);

      switch (serviceName) {
        case 'pledge' :
          _.setPledgeMemberList(data);
          _.setEvent();
          break;

        case 'friend' :
          _.setFriendMemberList(data);
          _.setEvent();
          break;
      }

    }, (data) => {
      handleApiError(data);

      _.setLoadingBar(wrap, false);

      switch (serviceName) {
        case 'pledge' :
          wrap.empty().append(`<li class="nodata">${BOARD.RETRY_LATER}</li>`);
          break;

        case 'friend' :
          wrap.empty().append(`<li class="nodata">${BOARD.RETRY_LATER}</li>`);
          break;
      }
    });
  }

  setPledgeMemberList(data) {
    const _ = this;

    if (!data || !Array.isArray(data.pledgeMemberList) || data.pledgeMemberList.length <= 0) {
      _.setNoData('pledge');
      return;
    }

    const members = data.pledgeMemberList || [];

    let tpl = '', gameOnOffTpl = '', giftTpl = '';
    members.forEach(function (element, index, array) {
      gameOnOffTpl = (element.status === 1) ? '<span class="game on">ON</span>' : '<span class="game">OFF</span>';
      // talkOnTpl = (element.ncTalkOn === true) ? '<span class="talk on">엔씨톡</span>' : '<span class="talk">엔씨톡</span>';
      giftTpl = (truthy(element.characterName) && falsy(element.own)) ? `<button class="btn-gift" data-serverId="${element.serverId}" data-charname="${element.characterName}"><span class="flag-gift">선물</span></button>` : ``;

      tpl += `<li>
                <strong class="name">${element.characterName}</strong>
                ${gameOnOffTpl}
                ${giftTpl}
              </li>`;
    });

    _.pledgeWrap.empty().append(tpl);



  }

  setFriendMemberList(data) {
    const _ = this;

    if (!data || !Array.isArray(data.gameFriendList) || data.gameFriendList.length <= 0) {
      _.setNoData('friend');
      return;
    }

    const members = data.gameFriendList;

    let tpl = '', gameOnOffTpl = '', giftTpl = '';
    members.forEach(function (element, index, array) {
      gameOnOffTpl = (element.playStatus === 'ON') ? '<span class="game on">ON</span>' : '<span class="game">OFF</span>';
      // talkOnTpl = (truthy(element.ncTalkOn)) ? '<span class="talk">엔씨톡</span>' : '';
      giftTpl = (truthy(element.characterName) && falsy(element.own)) ? `<button class="btn-gift" data-serverId="${element.serverId}" data-charname="${element.characterName}"><span class="flag-gift">선물</span></button>` : ``;

      tpl += `<li>
                <strong class="name">${element.characterName}</strong>
                ${gameOnOffTpl}
                ${giftTpl}
              </li>`;
    });

    _.friendWrap.empty().append(tpl);


  }

  setEvent(){
    const _ = this;

    _.pledgeWrap.find('.btn-gift').on('click', (e)=>{
      const ip = 'lin';
      const svrid = $(e.currentTarget).attr('data-serverId');
      const charName = $(e.currentTarget).attr('data-charname');

      window.ncrwd.ncoin.open(ip, svrid, charName);
    });

    _.friendWrap.find('.btn-gift').on('click', (e)=>{
      const ip = 'lin';
      const svrid = $(e.currentTarget).attr('data-serverId');
      const charName = $(e.currentTarget).attr('data-charname');
      window.ncrwd.ncoin.open(ip, svrid, charName);
    });

  }

  setNoData(serviceName) {
    const _ = this;

    switch (serviceName) {
      case 'pledge' :
        $('header .pledge', _.wrap).hide();
        _.pledgeWrap.remove();

        _.isPledgeNoData = true;
        break;

      case 'friend' :
        $('header .friend', _.wrap).hide();
        _.friendWrap.remove();

        _.isFriendNoData = true;
        break;
    }

    if (!_.isPledgeNoData && _.isFriendNoData) {
      _.navi.activate(1);

    } else if (_.isPledgeNoData && !_.isFriendNoData) {
      _.navi.activate(2);

    } else if (_.isPledgeNoData && _.isFriendNoData) {
      _.navi.destroy();

      $('article', _.wrap).append(_.tpl.JOIN_PLEDGE);
    }
  }

  setNaviOnlineCountData() {
    const _ = this;

    getDatasWithOption([{
      type: 'GET',
      url: `${_.option.apiDomain}/api/main/connection/onlineCount`,
      dataType: 'json',
      xhrFields: {withCredentials: true}

    }], (data) => {
      _.setNaviOnlineCount(data);

    }, (data) => {
      handleApiError(data);
    });
  }

  setNaviOnlineCount(data) {
    const _ = this,
      pledgeNum = numberWithCommas(parseInt10(data.pledge || 0)),
      friendNum = numberWithCommas(parseInt10(data.friend || 0));

    $('.pledge > a', _.wrap).text(`혈맹 ${pledgeNum}`);
    $('.friend > a', _.wrap).text(`친구 ${friendNum}`);
  }

  setNavi() {
    const _ = this;

    _.navi = new Navi({
      btns: $('header li a', _.wrap),
      activateCallback: function (obj) {
        let btns = $(_.navi.getBtns()),
          btn = $(_.navi.getBtn(obj.index));

        btns.parent().removeClass('on');
        btn.parent().addClass('on');

        const serviceName = _.getServiceNameByNavi(btn.parent());
        _.switchCharacterOnWrap(serviceName);
      }
    }).init();
  }

  getServiceNameByNavi(btnParent) {
    const classes = $(btnParent).attr('class').split(' '),
      serviceName = (classes.indexOf('pledge') >= 0) ? 'pledge' : 'friend';

    return serviceName;
  }

  switchCharacterOnWrap(serviceName) {
    const _ = this;

    switch (serviceName) {
      case 'pledge' :
        _.pledgeWrap.show();
        _.friendWrap.hide();
        break;

      case 'friend' :
        _.pledgeWrap.hide();
        _.friendWrap.show();
        break;
    }
  }

  setLoadingBar(wrap, flag) {
    $('.loadingbar', wrap).remove();

    if (truthy(flag)) $(wrap).append(getLoadingBarTpl());
  }
}

export default Connect;


// WEBPACK FOOTER //
// ./_src/js/main/my/Connection.js